// extracted by mini-css-extract-plugin
export default {"content":"ModalContent_content__CbGjl","body":"ModalContent_body__l5w2U"};